import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/company/page', data, {
    trim: true
  })
}
export function treeList (data) {
  return request.post('/business/company/tree', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/company/exportExcel', data, {
    trim: true,
    download: true
  })
}
export function companySync (data) {
  return request.post('/business/company/syncAll', data)
}
// 创建
export function create (data) {
  return request.post('/business/company/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/company/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/company/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/company/delete/batch', {
    params: {
      ids
    }
  })
}
